var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("studip-dialog", {
    attrs: {
      width: "890",
      title: _vm.$gettext("Bild auswählen"),
      closeText: _vm.$gettext("Schließen"),
      height: "640",
    },
    on: {
      close: _vm.onClose,
    },
    scopedSlots: _vm._u([
      {
        key: "dialogContent",
        fn: function fn() {
          return [
            _c("Selector", {
              attrs: {
                "stock-images": _vm.stockImages,
              },
              on: {
                select: _vm.onSelectImage,
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }